import React, { memo, useCallback } from "react";
import BasicTable from "../../Components/Global_Components/reacttable/table";

const DrugTable = ({ data, columns, pagination, setPagination, datacount }) => {

    const handlePageSizeChange = useCallback((pageSize) => {
        setPagination((prev) => {
            if (prev.pageSize === pageSize) return prev;
            return { ...prev, pageSize, pageIndex: 1 };
        });
    }, []);

    const handlePageIndexChange = useCallback((pageIndex) => {
        setPagination((prev) => {
            if (prev.pageIndex === pageIndex) return prev;
            return { ...prev, pageIndex };
        });
    }, []);



    return (
        <div className="table-container">
            <BasicTable
                columns={columns}
                data={data}
                pagesize={handlePageSizeChange}
                pageindex={handlePageIndexChange}
                dtpagesize={pagination.pageSize}
                dtpageindex={pagination.pageIndex}
                datacount={datacount}
            />
        </div>
    );
};

export default memo(DrugTable);
